var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 7.5C9.53999 7.5 9.16666 7.12667 9.16666 6.66667C9.16666 6.20667 9.53999 5.83333 9.99999 5.83333C10.46 5.83333 10.8333 6.20667 10.8333 6.66667C10.8333 7.12667 10.46 7.5 9.99999 7.5ZM10.8333 13.3333C10.8333 13.7933 10.46 14.1667 9.99999 14.1667C9.53999 14.1667 9.16666 13.7933 9.16666 13.3333V9.16667C9.16666 8.70667 9.53999 8.33333 9.99999 8.33333C10.46 8.33333 10.8333 8.70667 10.8333 9.16667V13.3333ZM9.99999 1.66667C5.39749 1.66667 1.66666 5.3975 1.66666 10C1.66666 14.6025 5.39749 18.3333 9.99999 18.3333C14.6017 18.3333 18.3333 14.6025 18.3333 10C18.3333 5.3975 14.6017 1.66667 9.99999 1.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationInfo);
export default __webpack_public_path__ + "static/media/notificationInfo.4601fe72fe75efbf15637ee63a4900e0.svg";
export { ForwardRef as ReactComponent };